import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { stripeService } from '../../../services/stripeService';

const PaymentHistoryTable = ({ transactions }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const handleDownloadInvoice = (transaction) => {
    if (transaction?.invoicePdf) {
      window.open(transaction?.invoicePdf, '_blank');
    } else if (transaction?.receiptUrl) {
      window.open(transaction?.receiptUrl, '_blank');
    } else {
      console.log('No invoice available for transaction:', transaction?.id);
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-warm overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <h2 className="text-xl md:text-2xl font-heading font-bold">Payment History</h2>
        <p className="text-sm md:text-base text-muted-foreground mt-1">View all your transactions and download invoices</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Date</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Description</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Amount</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Status</th>
              <th className="text-right p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Invoice</th>
            </tr>
          </thead>
          <tbody>
            {transactions?.map((transaction) => (
              <tr key={transaction?.id} className="border-b border-border hover:bg-muted/20 transition-smooth">
                <td className="p-3 md:p-4 text-xs md:text-sm font-mono whitespace-nowrap">
                  {formatDate(transaction?.createdAt)}
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm">
                  <div>
                    <p className="font-medium">{transaction?.description || 'Premium Monthly Subscription'}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {transaction?.paymentMethodType || 'Card'} {transaction?.paymentMethodLast4 ? `****${transaction?.paymentMethodLast4}` : ''}
                    </p>
                  </div>
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm font-mono font-semibold whitespace-nowrap">
                  {stripeService?.formatAmount(transaction?.amount, transaction?.currency)}
                </td>
                <td className="p-3 md:p-4">
                  <span className={`inline-flex items-center gap-1.5 px-2 md:px-3 py-1 rounded-full text-xs font-medium ${stripeService?.getPaymentStatusColor(transaction?.status)}`}>
                    <Icon name={stripeService?.getPaymentStatusIcon(transaction?.status)} size={12} />
                    {stripeService?.getPaymentStatusLabel(transaction?.status)}
                  </span>
                </td>
                <td className="p-3 md:p-4 text-right">
                  {(transaction?.status === 'succeeded' && (transaction?.invoicePdf || transaction?.receiptUrl)) && (
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Download"
                      iconPosition="left"
                      onClick={() => handleDownloadInvoice(transaction)}
                    >
                      <span className="hidden md:inline">Invoice</span>
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {transactions?.length === 0 && (
        <div className="p-8 md:p-12 text-center">
          <Icon name="Receipt" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
          <p className="text-sm md:text-base text-muted-foreground mb-1">No payment history</p>
          <p className="text-xs md:text-sm text-muted-foreground">Your transactions will appear here</p>
        </div>
      )}
    </div>
  );
};

export default PaymentHistoryTable;